angular.module('unergie.main')
.directive('userInfoAccount', ($state, $timeout, ApiUser, AlertManager, BoFeaturesService, MetaWatcher, DataAccess, ApiAdmin, DataAccessFeatures,
    AdminComments, TogglerUtils, FileUploader, BarcodeService, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/account/userInfoAccount.html',
        link($scope) {
            $scope.togglerUtils = TogglerUtils
            $scope.traineeMode = BoFeaturesService.isFeatureOn('traineeMode')
            $scope.showInvoiceCommunicationChannel = BoFeaturesService.isFeatureOn('showInvoiceCommunicationChannel')
            $scope.canDeleteImport = BoFeaturesService.getModuleFeatures('accountinfo').canDeleteImport
            $scope.canImportV2 = BoFeaturesService.getModuleFeatures('accountinfo').canExportContractV2
            $scope.canByPassBalanceCheck = BoFeaturesService.isFeatureOn('canByPassBalanceCheck')

            $scope.isClient = $scope.account && $scope.account.category !== 'user'

            $scope.noSecond = '--'
            $scope.civs = [
                { label: $scope.noSecond, value: null },
                { label: 'M.', value: 'M.' },
                { label: 'Mme', value: 'Mme' },
            ]

            // UPDATE CIVILITE
            $scope.updateCivMode = false

            $scope.isFeatureOn = BoFeaturesService.isFeatureOn
            $scope.showTools = !BoFeaturesService.get('isEnvProd')

            $scope.toggleUpdateCivMode = () => {
                $scope.updateCivMode = !$scope.updateCivMode
            }

            $scope.saveCiv = () => {
                const payload = {
                    civ: $scope.account.civ,
                    sn: $scope.account.sn.trim(),
                    givenname: $scope.account.givenname.trim(),
                    civ2: $scope.account.civ2,
                    sn2: $scope.account.sn2 && $scope.account.sn2.trim(),
                    givenname2: $scope.account.givenname2 && $scope.account.givenname2.trim(),
                }
                if ($scope.account.civ2 === null) {
                    payload.civ2 = null
                    payload.sn2 = null
                    payload.givenname2 = null
                }
                return ApiUser.updateAccount({ id_account: $scope.account.id }, payload).$promise.then(() => {
                    AlertManager.success('Civilité modifiée')
                    let comment = `<b>AUTOMATIQUE</b> : Civilité mise à jour : <b>${$scope.account.civ} ${$scope.account.sn} ${$scope.account.givenname}</b>`
                    if ($scope.account.civ2 !== null) {
                        comment += ` et <b>${$scope.account.civ2} ${$scope.account.sn2} ${$scope.account.givenname2}</b>`
                    }
                    AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                    $scope.toggleUpdateCivMode()
                    $scope.refreshAccount()
                }).catch(ErrorCatcher)
            }

            // IMPORT CONTRACT
            $scope.fetchingImportsFromS3 = false


            $scope.prepareImport = () => {
                $scope.fetchImportsFromS3 = _.once(() => {
                    $scope.importContractFields.s3File.fetching = true
                    return ApiAdmin.listImportableContracts().$promise.then((results) => {
                        $scope.importContractFields.s3File.enum = _.map(_.orderBy(results, 'contract'), (r) => {
                            return { label: `${r.contract} (${moment(r.date).format('DD/MM/YYYY')})`, value: r.Key }
                        })
                    })
                    .catch(ErrorCatcher)
                    .finally(() => {
                        $scope.importContractFields.s3File.fetching = false
                    })
                })
            }

            $scope.prepareImport()

            $scope.importContractFields = {
                fromS3: {
                    hidden: !$scope.canImportV2,
                    label: 'Import depuis',
                    type: 'radio',
                    enum: [
                        { label: 'Votre ordinateur', value: false },
                        { label: 'Depuis le répertoire partagé', value: true },
                    ],
                },
                s3File: {
                    label: 'Contrat sauvegardé',
                    type: 'typeahead',
                    limitTo: 15,
                    required: true,
                    hidden: (template) => {
                        if (template.fromS3) {
                            $scope.fetchImportsFromS3()
                        }
                        return !template.fromS3
                    },
                    enum: [],
                },
                contract: {
                    label: 'Fichier local',
                    hidden: (template) => template.fromS3,
                    type: 'file',
                    required: true,
                    accept: '.json,.zip',
                },
                contractId: {
                    label: `Importer avec cet id (optionnel)`,
                    placeholder: 'CTXXXXXX',
                    type: 'text',
                    forceUppercase: true,
                },
                dailyConsumption: {
                    label: 'Importer les données de consommation',
                    type: 'radio',
                    enum: [{
                        label: 'Oui',
                        value: true,
                    }, {
                        label: 'Non',
                        value: false,
                    }],
                },
            }
            $scope.importContractPayload = {
                fromS3: false,
                contract: new FileUploader({
                    url: '/api-admin/import/contract',
                    alias: 'file',
                    formData: [{ customerId: $scope.account.customer_id }],
                    autoUpload: false,
                    removeAfterUpload: true,
                    method: 'POST',
                    onSuccessItem(item, response, status, headers) {
                        AlertManager.success(`Contrat importé ${response.contract}`)
                        return $state.go('userInfoOnContract', { customerId: $scope.account.customer_id, contractId: response.contract })
                    },
                    onErrorItem(item, response, status, headers) {
                        return ErrorCatcher({ data: response })
                    },
                    onBeforeUploadItem(item) {
                        if ($scope.importContractPayload.contractId) {
                            item.formData.push({ contractId: $scope.importContractPayload.contractId })
                            delete $scope.importContractPayload.contractId
                        }
                        item.formData.push({ dailyConsumption: $scope.importContractPayload.dailyConsumption })
                    },
                }),
                dailyConsumption: false,
            }

            $scope.importContractFromS3 = (s3File) => {
                $scope.importingContract = true
                return ApiAdmin.importContract({ customerId: $scope.account.customer_id, s3File }).$promise
                .then((response) => {
                    AlertManager.success(`Contrat importé ${response.contract}`)
                    $timeout(() => {
                        $state.go('userInfoOnContract', { customerId: $scope.account.customer_id, contractId: response.contract })
                    })
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    $scope.importingContract = false
                })
            }

            $scope.importContract = function () {
                if ($scope.importContractPayload.fromS3) {
                    $scope.importContractFromS3($scope.importContractPayload.s3File)
                }
                return $scope.importContractPayload.contract.uploadAll()
            }

            $scope.prevent = (e) => {
                e.preventDefault()
                e.stopPropagation()
            }

            $scope.deleteImport = (importObj) => {
                importObj.deletingImport = true
                return ApiAdmin.deleteImportFile({ path: importObj.value }).$promise
                .then((response) => {
                    AlertManager.success(`Fichier supprimé`)
                    $scope.prepareImport()
                    return $scope.fetchImportsFromS3()
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    importObj.deletingImport = false
                })
            }

            $scope.fetchMetadata = (importObj) => {
                return ApiAdmin.fetchMetadata({ path: importObj.value })
            }

            // RESET PASSWORD
            $scope.resetPassword = () =>
                ApiUser.resetPassword({ email: $scope.account.mail }).$promise.then(() => {
                    AlertManager.success(`Email envoyé à ${$scope.account.mail}`)
                    MetaWatcher.notif('CONTACTS_CHANGED')
                }).catch(ErrorCatcher)

            if ($scope.showInvoiceCommunicationChannel) {
                $scope.changeInvoiceComChannel = {
                    payload: {
                        invoice_communication_channel: $scope.account.billingaccount.invoice_communication_channel || 'EMAIL',
                    },
                    fields: {
                        invoice_communication_channel: {
                            label: 'Mode',
                            type: 'radio',
                            required: true,
                            enum: [{ label: 'Par e-mail', value: 'EMAIL' }, { label: 'Par courrier postal', value: 'POST' }],
                        },
                        label: {
                            label: (payload) => {
                                return payload.invoice_communication_channel !== 'POST' ? '' :
                                    `<span class="red">
                                    <span class="fa fa-warning"></span>&nbsp;
                                    Ce mode de contact n'est pas recommandé pour des raisons écologiques (avec une réception par email, le client peut si besoin imprimer sa facture) !
                                    </span>`
                            },
                            type: 'label',
                        },
                    },
                    confirm() {
                        $scope.modifyingInvoiceComChannel = true
                        return DataAccess.modifyInvoiceComChannel({ id_account: $scope.account.id }, $scope.changeInvoiceComChannel.payload).$promise
                        .then(() => {
                            AlertManager.success('Mode modifié')
                            $scope.refreshAccount()
                        })
                        .catch(ErrorCatcher)
                        .finally(() => {
                            $scope.modifyingInvoiceComChannel = false
                        })
                    },
                }
            }

            $scope.isFullPaper = () => {
                return $scope.account.mail.includes('@client.plum.fr')
            }

            $scope.getInvoiceCommunicationChannel = () => {
                switch ($scope.account.billingaccount.invoice_communication_channel) {
                    case 'POST':
                        return 'papier'
                    case 'EMAIL':
                    default:
                        return 'e-mail'
                }
            }

            // Irrecoverability
            $scope.isIrrecoverable = $scope.account.irrecoverabilityCertificates && !!$scope.account.irrecoverabilityCertificates.length

            // FEATURES
            $scope.editFeatures = false
            $scope.featureList = null
            $scope.toggleEdit = function () {
                $scope.editFeatures = !$scope.editFeatures
                if (!$scope.editFeatures) {
                    return $scope.refreshFeatures()
                }
            }

            let userFeatureObj = null

            $scope.refreshFeatures = () => DataAccess.features({ id_account: $scope.account.id }).$promise.then((data) => {
                userFeatureObj = data
                $scope.userFeature = data.id_feature
            })
            .catch(ErrorCatcher)

            $scope.changeFeature = (featureId) => {
                $scope.userFeature = featureId
            }

            $scope.saveFeatures = function () {
                if (userFeatureObj.id) {
                    DataAccess.updateUserFeature({ id: userFeatureObj.id }, { id_feature: $scope.userFeature }).$promise
                    .then((data) => $scope.refreshFeatures())
                    .catch(ErrorCatcher)
                } else {
                    DataAccess.addUserFeature({ id_account: $scope.account.id, id_feature: $scope.userFeature }).$promise
                    .then((data) => $scope.refreshFeatures())
                    .catch(ErrorCatcher)
                }
                $scope.editFeatures = false
            }

            $scope.showFeatures = () => {
                return TogglerUtils.isPlum() && $scope.isClient && $scope.isFeatureOn('expertMode')
            }

            if ($scope.showFeatures()) {
                $scope.refreshFeatures()
                DataAccessFeatures.getFeatures().$promise.then((data) => {
                    $scope.featureList = data
                })
                .catch(ErrorCatcher)
            }

            $scope.getOverdueContractsString = () => {
                const contracts = _.map($scope.account.balances && $scope.account.balances.overdueContracts, (value, key) => `${key}: ${value} €`)
                return contracts.length === 1 ? `Un contrat présente un solde débiteur : ${contracts[0]}`
                    : `Plusieurs contrats présentent des soldes débiteurs : ${contracts.join(', ')}`
            }

            $scope.newDraft = () => {
                window.open($state.href('salesTunnelV3', { user: $scope.account.id }), '_blank')
            }
        },
    })
)
